<div mat-dialog-title>
  <div class="d-flex justify-content-between" *ngFor="let data of gridData">
    <p>Peer Review Request No. {{data.peer_review_refno}}</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>




<div mat-dialog-content class="m-0">
  <div class="eip-mxy-5" *ngFor="let data of gridData">
    <mat-accordion class="mat-dialog-accordion" [multi]="true">
      
      <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
              <mat-panel-title id="accAccountCodeMaster">
                  <div class="d-flex ">
                      <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                          <p class="ff-3">Request Details</p>
                      </div>
                  </div>
              </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="eip-mt-20">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Request No.</p>
                  <p class="view-data">{{data.peer_review_refno}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Review Type</p>
                  <p class="view-data">{{data.review_type}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Description</p>
                  <p class="view-data">{{data.project_description}}
                  </p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Request Status</p>
                  <p class="view-data">{{data.document_status}}</p>
                </div>
              </div>
              <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Scope Of Review</p>
                  <p class="view-data" id="lblJob">
                    {{data.scope_of_review}}
                  </p>
                </div>
              </div> -->
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Services Included</p>
                  <p class="view-data" id="lblJob">
                    {{data.services_included}}
                  </p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20 mt-2">
                  <p class="view-label peer-view-lable">Required Documents</p>
                  <!-- <p class="view-data" id="lblJob">
                    {{data.required_documents}}
                  </p> -->
                  <div class="" *ngIf="!isChecklistAvailable">
                    <i class="fa fa-upload" title="Upload Checklist" (click)="uploadPeerReviewChecklist()"
                      style="cursor:pointer;" aria-hidden="true"></i><span class="" style="cursor:pointer;font-weight: bolder;"
                      (click)="uploadPeerReviewChecklist()">  Upload Checklist</span>
                  </div>
                </div>
                <div class="justify-content-center" *ngIf="isChecklistAvailable">
                  <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="openFile('1')" >
                  </i>
                  <!-- <i class="fa fa-paperclip fs-16 eip-mr-5 eip-link" aria-hidden="true" (click)="openFile('1')"></i> -->
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20 mt-2">
                  <p class="view-label peer-view-lable">Project OverView</p>
                  <!-- <p class="view-data" id="lblJob">
                    {{data.required_documents}}
                  </p> -->
                  <div class="" *ngIf="!isProjectOverviewAvailable">
                    <i class="fa fa-upload" title="Upload Project Overview" (click)="uploadProjectOverview()"
                      style="cursor:pointer;" aria-hidden="true"></i><span class="" style="cursor:pointer;font-weight: bolder;"
                      (click)="uploadProjectOverview()">  Upload Project Overview</span>
                  </div>
                  <div class="justify-content-center" *ngIf="isProjectOverviewAvailable">
                    <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="openFile('0')" >
                    </i>
                  </div>
                  <!-- <i class="fa fa-paperclip fs-16 eip-mr-5 eip-link" aria-hidden="true" (click)="openFile('0')"></i> -->
                </div>
              </div>
              <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Type Of Structure</p>
                  <p class="view-data" id="lblJob">
                    {{data.type_of_structure}}
                  </p>
                </div>
              </div> -->
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Stages Of Review</p>
                  <p class="view-data">{{data.stages_of_review}}</p>
                </div>
              </div>
              <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Peer Review Reference</p>
                  <p class="view-data" id="lblJob">
                        {{data.peer_review_refno}}
                  </p>
                </div>
              </div> -->
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Date</p>
                  <p class="view-data" id="lblwarehouse">
                        {{data.review_date | date:'dd-MMM-yyyy'}}
                  </p>
                </div>
              </div>
              <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Document Location</p>
                  <p class="view-data">{{data.document_location}}</p>
                </div>
              </div> -->
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Video Conference?</p>
                  <p class="view-data">{{data.vc_required}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Document Location</p>
                  <!-- <a herf="data.document_location" target="_blank"> Link </a> -->
                  <!-- <i aria-hidden="true" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" herf="{{data.document_location}}" target="_blank" title="{{data.document_location}}"></i> -->
                  <!-- <a class="view-data" target="_blank">{{data.document_location}}</a> -->
                  <a href="{{data.document_location}}" target="blank">
                    <!-- <span class="filabel" title="Incident Management">Incident Mgmt</span> -->
                    <i class="fa fa-paperclip fs-16 eip-mr-5 eip-link" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">ECD For Project</p>
                  <p class="view-data">{{data.ecd_for_project}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">MEIC For Project</p>
                  <p class="view-data">{{data.mep_ecd_for_project}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">DEIC For Project</p>
                  <p class="view-data">{{data.decd_for_project}}</p>
                </div>
              </div>
            </div>
          </div>
      </mat-expansion-panel>
      
      <!-- <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
              <mat-panel-title>
                  <div class="d-flex ">
                      <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                          <p class="ff-3">Project Details</p>
                      </div>
                  </div>
              </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="eip-mt-20">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Name</p>
                  <p class="view-data">{{data.project_name}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Code</p>
                  <p class="view-data" id="lblJob">
                        {{data.project_code}}
                  </p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Brief</p>
                  <p class="view-data" id="lblJob">
                    {{data.project_brief_desc}}
                  </p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Client Name</p>
                  <p class="view-data">{{data.client_name}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Building Type</p>
                  <p class="view-data" id="lblwarehouse">
                        {{data.building_type}}
                  </p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Nature of Job</p>
                  <p class="view-data">{{data.nature_of_project}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Type of Contract</p>
                  <p class="view-data">{{data.contract_type}}</p>
                </div>
              </div>
              
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Value (Rs in lakhs)</p>
                  <p class="view-data">{{data.project_value_in_lakhs}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Design Fees (Rs in lakhs)</p>
                  <p class="view-data" id="lblJob">
                    {{data.design_fee_in_lakhs}}
                  </p>
                </div>
              </div>
              
              <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Scope of Work</p>
                  <p class="view-data" id="lblJob">
                   {{data.project_scope_of_work}}
                  </p>
                </div>
              </div> 
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Built-up Area</p>
                  <p class="view-data">{{data.built_up_area_in_sqm}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Site Area</p>
                  <p class="view-data">{{data.plot_area_in_sqm}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Proof Consultant Name</p>
                  <p class="view-data">{{data.proof_consultant_name}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Architectural Consultant</p>
                  <p class="view-data">{{data.architectural_consultant_name}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="view-info eip-mb-20">
                    <p class="view-label peer-view-lable">Structural Consultant</p>
                    <p class="view-data">{{data.structural_consultant_name}}</p>
                  </div>
                </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Any Consultants to be appointed by EDRC</p>
                  <p class="view-data">{{data.any_other_consultants}}</p>
                </div>
              </div>
              <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Scope for Peer Review</p>
                  <p class="view-data">{{data.scope_for_peer_review}}</p>
                </div>
              </div> 
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project Start Date</p>
                  <p class="view-data">{{data.project_start_date | date:'dd-MMM-yyyy'}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Project End Date</p>
                  <p class="view-data">{{data.project_end_date | date:'dd-MMM-yyyy'}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Tender Submission Date</p>
                  <p class="view-data">{{data.project_submission_date | date:'dd-MMM-yyyy'}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Date of LOI</p>
                  <p class="view-data">{{data.date_of_loi | date:'dd-MMM-yyyy'}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">Date</p>
                  <p class="view-data">{{data.review_date | date:'dd-MMM-yyyy'}}</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="view-info eip-mb-20">
                  <p class="view-label peer-view-lable">EDMS Availability</p>
                  <p class="view-data">{{data.edms_available}}</p>
                </div>
              </div>
            </div>
          </div>
      </mat-expansion-panel> -->

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
            <mat-panel-title>
                <div class="d-flex ">
                    <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                        <p class="ff-3">Workflow Details</p>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="eip-mt-20">
          <div class="row">
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="d-flex">
                <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                    <p class="ff-3">Presenter Details</p>
                </div>
              </div>
              <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="presenterdata" [filterable]="enableFilter"
              [selectable]="true" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChange($event)"
              [skip]="skip" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true"
              (mouseover)="onHover($event)" (pageChange)="pageChange($event)">
              <ng-template kendoPagerTemplate>
                <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                <div class="k-grid-toolbar-content d-flex">

                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span>
                    </span>
                  </div>
                  <div class="pagination-container">
                    <p id="lblShowDetails">Show</p>
                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                    </kendo-pager-page-sizes>
                    <span>Items</span>
                  </div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                  </div>
                  <div class="icons-container">
                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true"
                      [ngClass]="{'ellipsis-active' : toggleListIcons}"
                      (click)="toggleListIcons = !toggleListIcons"></i>
                    <div class="d-none d-md-flex align-items-md-center"
                      [ngClass]="{'icons-list-type' : toggleListIcons}">
                    </div>
                  </div>
                </div>
              </ng-template>
              <kendo-grid-column title="SL No" filterable="false" width="50">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{rowIndex + 1}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Discipline" field="discipline" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
                      {{dataItem.discipline}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Presenter Name" field="dprP_Presenter_Name" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="no-wrap" eipTooltip="{{dataItem.dprP_Presenter_Name}}" eipTooltipPosition="auto">
                      {{dataItem.dprP_Presenter_Name}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Mail ID" field="dprP_Presenter_Mail_Id" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="no-wrap" eipTooltip="{{dataItem.dprP_Presenter_Mail_Id}}" eipTooltipPosition="auto">
                      {{dataItem.dprP_Presenter_Mail_Id}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="From Time" field="hprR_Presentation_From_Time" width="100">
              </kendo-grid-column>
              <kendo-grid-column title="To Time" field="hprR_Presentation_To_Time" width="100">
              </kendo-grid-column>
              <kendo-grid-column title="Remarks" field="dprP_Additional_Remarks" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="no-wrap" eipTooltip="{{dataItem.dprP_Additional_Remarks}}" eipTooltipPosition="auto">
                      {{dataItem.dprP_Additional_Remarks}}
                  </span>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
            </div> -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="d-flex">
                <!-- <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                    <p class="ff-3">Workflow Details</p>
                </div> -->
              </div>
              <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="docflow" [filterable]="enableFilter"
            [selectable]="true" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChange($event)"
            [skip]="skip" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true"
            (mouseover)="onHover($event)" (pageChange)="pageChange($event)">
            <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
            </ng-template>
            <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex">

                <div class="flex-grow-1 mat-panel-headerbar"></div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span>
                  </span>
                </div>
                <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                  </kendo-pager-page-sizes>
                  <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
                </div>
                <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true"
                    [ngClass]="{'ellipsis-active' : toggleListIcons}"
                    (click)="toggleListIcons = !toggleListIcons"></i>
                  <div class="d-none d-md-flex align-items-md-center"
                    [ngClass]="{'icons-list-type' : toggleListIcons}">
                  </div>
                </div>
              </div>
            </ng-template>
            <kendo-grid-column title="SL_No"  filterable="false" width="30">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex + 1}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Action By" field="action_By" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.action_By}}" eipTooltipPosition="auto">
                    {{dataItem.action_By}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Description" field="action_Desc" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.action_Desc}}" eipTooltipPosition="auto">
                    {{dataItem.action_Desc}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Action On" width="100" [minResizableWidth]="30">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>{{dataItem.action_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Remarks" field="remarks" width="120">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.remarks}}" eipTooltipPosition="auto">
                    {{dataItem.remarks}}
                </span>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
            </div>
          </div>
        </div>
    </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
            <mat-panel-title>
                <div class="d-flex ">
                    <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                        <p class="ff-3">Panel Members</p>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="eip-mt-20">
          <div class="d-flex" *ngIf="location">
            <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
              <p class='font-weight-bold eip-pr-20'>Location : <span> {{location}} </span> </p>
            </div>
          </div>
          <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="panel" [filterable]="enableFilter"
              [selectable]="true" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChange($event)"
              [skip]="skip" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true"
              (mouseover)="onHover($event)" (pageChange)="pageChange($event)">
              <ng-template kendoPagerTemplate>
                <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                <div class="k-grid-toolbar-content d-flex">

                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span>
                    </span>
                  </div>
                  <div class="pagination-container">
                    <p id="lblShowDetails">Show</p>
                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                    </kendo-pager-page-sizes>
                    <span>Items</span>
                  </div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                  </div>
                  <div class="icons-container">
                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true"
                      [ngClass]="{'ellipsis-active' : toggleListIcons}"
                      (click)="toggleListIcons = !toggleListIcons"></i>
                    <div class="d-none d-md-flex align-items-md-center"
                      [ngClass]="{'icons-list-type' : toggleListIcons}">
                    </div>
                  </div>
                </div>
              </ng-template>
              <kendo-grid-column title="SL No" filterable="false" width="50">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{rowIndex + 1}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Member Type" field="member_category" width="100">
              </kendo-grid-column>
              <kendo-grid-column title="Member" field="member_Name" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="no-wrap" eipTooltip="{{dataItem.member_Name}}" eipTooltipPosition="auto">
                      {{dataItem.member_Name}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <!-- <kendo-grid-column title="PS No." field="member_PSNo" width="100">
              </kendo-grid-column> -->
              <kendo-grid-column title="Role" field="member_Role" width="100">
              </kendo-grid-column>
              <kendo-grid-column title="Discipline" field="member_Discipline" width="100">
              </kendo-grid-column>              
              <kendo-grid-column title="Final Comments Submitted" field="lprM_Comments_Submitted" width="100" [minResizableWidth]="110">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.lprM_Comments_Submitted == 'Y'; else not">
                    Yes
                  </div>
                </ng-template>
                <ng-template #not>
                  No
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Final Response Submitted" field="lprM_Response_Submitted" width="100">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.lprM_Response_Submitted == 'Y'; else not">
                    Yes
                  </div>
                </ng-template>
                <ng-template #not>
                  No
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Final Impacts Submitted" field="lprM_Impact_Submitted" width="100">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.lprM_Impact_Submitted == 'Y'; else not">
                    Yes
                  </div>
                </ng-template>
                <ng-template #not>
                  No
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
          <mat-panel-title>
              <div class="d-flex ">
                  <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                      <p class="ff-3"> Comments and Response </p>
                  </div>
              </div>
          </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="eip-mt-20">
        <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="cri" [filterable]="enableFilter"
            [selectable]="true" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChange($event)"
            [skip]="skip" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true" (excelExport)="onExcelExport($event)"
            (mouseover)="onHover($event)" (pageChange)="pageChange($event)">
            <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
            </ng-template>
            <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex">

                <div class="flex-grow-1 mat-panel-headerbar"></div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
                </div>
                <div class="icons-container">
                  <div class="icon-wrap">
                    <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10"
                      style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to
                      Excel</button>
                  </div>
                  <div class="d-none d-md-flex align-items-md-center">
                    <div class="icon-wrap">
                      <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                      <span class="list-icon-name">Filter</span>
                    </div>
                  </div>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span>
                  </span>
                </div>
                <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                  </kendo-pager-page-sizes>
                  <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
                </div>
                <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true"
                    [ngClass]="{'ellipsis-active' : toggleListIcons}"
                    (click)="toggleListIcons = !toggleListIcons"></i>
                  <div class="d-none d-md-flex align-items-md-center"
                    [ngClass]="{'icons-list-type' : toggleListIcons}">
                  </div>
                </div>
              </div>
            </ng-template>
            <kendo-grid-column title="SL No" field="Sl_No" filterable="false" width="50">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex + 1}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Discipline" field="discipline" width="110">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
                    {{dataItem.discipline}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Commented By / Date" field="commented_By" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.commented_By}} / {{ dataItem.commented_On | date:'dd-MMM-yyyy' }}" eipTooltipPosition="auto">
                    {{dataItem.commented_By}} / {{ dataItem.commented_On | date:'dd-MMM-yyyy' }}
                </span>
              </ng-template>
            </kendo-grid-column>
            <!-- <kendo-grid-column title="Commented On" width="100" [minResizableWidth]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>{{dataItem.commented_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
            </kendo-grid-column> -->
            <kendo-grid-column title="Comments" field="comment" width="250">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.comment}}" eipTooltipPosition="auto">
                    {{dataItem.comment}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Comment Type / Category" field="potential_Comment" width="200">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div class="row d-flex">
                  <div class="col-xl-8 col-xs-8 col-md-8 col-sm-12">
                    {{dataItem.potential_Comment}}
                  </div>
                  <div class="col-xl-4 col-xs-4 col-md-4 col-sm-12" style="margin-top: 10px;">
                    <span *ngIf="dataItem.comment_Category=='Medium Risk'">
                      <p style="width: 25px;height: 25px; background-color: #ffbf00;"></p> 
                    </span>
                    <span *ngIf="dataItem.comment_Category=='High Risk'">
                      <p style="width: 25px;height: 25px; background-color: red;"></p>
                    </span>
                    <span *ngIf="dataItem.comment_Category=='Low Risk'">
                      <p style="width: 25px;height: 25px; background-color: darkgreen;"></p>
                    </span>
                  </div>
                </div>
              </ng-template>
            </kendo-grid-column>
            <!-- <kendo-grid-column title="Comment Category" field="comment_Category" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="dataItem.comment_Category=='Medium Risk'" style="padding:5px;background-color: #ffbf00; font-weight: 1000;color:#fff">
                    {{dataItem.comment_Category}}
                </div>
                <div *ngIf="dataItem.comment_Category=='High Risk'" style="padding:5px;background-color: red; font-weight: 1000;color:#fff">
                    {{dataItem.comment_Category}}
                </div>
                <div *ngIf="dataItem.comment_Category=='Low Risk'" style="padding:5px;background-color: darkgreen; font-weight: 1000;color:#fff">
                    {{dataItem.comment_Category}}
                </div>
            </ng-template>
            </kendo-grid-column> -->
            <kendo-grid-column title="Comments Attachment" width="80">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="dataItem.is_Comments_Attachment_Available=='Yes'; else not">
                  <i aria-hidden="true" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewCommentsAttachmentClick(dataItem)"></i>
                </div>
              </ng-template>
              <ng-template #not>
                No
              </ng-template>
            </kendo-grid-column>
            <!-- <kendo-grid-column title="Response Received" field="is_Response_Received" width="100">
            </kendo-grid-column> -->
            <kendo-grid-column title="Response By / Date" field="response_Received_From" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.response_Received_From}} / {{dataItem.response_Received_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">
                    {{dataItem.response_Received_From ? dataItem.response_Received_From + '/':''}} {{dataItem.response_Received_On | date:'dd-MMM-yyyy'}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <!-- <kendo-grid-column title="Responsed On" width="100" [minResizableWidth]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>{{dataItem.response_Received_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
            </kendo-grid-column> -->
            <kendo-grid-column title="Response By Project Team" field="project_Design_Team_Response" width="250">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.project_Design_Team_Response}}" eipTooltipPosition="auto">
                  {{dataItem.project_Design_Team_Response}} {{dataItem.project_Design_Team_Response == 'Comply' ? '(Action) - ' : dataItem.project_Design_Team_Response == 'Unable to comply' ? '(Reason) - ':''}} {{dataItem.project_Design_Team_Response == 'Comply' ? dataItem.response_Remarks : dataItem.disAgree_Reason_Remarks}} 
                </span>
              </ng-template>
            </kendo-grid-column>

            <!-- <kendo-grid-column title="Action" field="response_Remarks" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.response_Remarks}}" eipTooltipPosition="auto">
                    {{dataItem.response_Remarks}}
                </span>
              </ng-template>
            </kendo-grid-column> -->
            
            <kendo-grid-column title="Action By / Date" field="response_Entry_Done_By" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.response_Entry_Done_By}} / {{dataItem.response_Entry_Done_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">
                    {{dataItem.response_Entry_Done_By ? dataItem.response_Entry_Done_By + '/':''}} {{dataItem.response_Entry_Done_On | date:'dd-MMM-yyyy'}}
                </span>
              </ng-template>
            </kendo-grid-column>
            <!-- <kendo-grid-column title="Action On" width="100" [minResizableWidth]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>{{dataItem.response_Entry_Done_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
            </kendo-grid-column> -->

            <!-- <kendo-grid-column title="Status Of Action Point" field="impactOpenClose" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.impactOpenClose}}" eipTooltipPosition="auto">
                    {{dataItem.impactOpenClose}}
                </span>
              </ng-template>
            </kendo-grid-column> -->
            <!-- <kendo-grid-column title="Action With / Date" field="impactStatus" width="110">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.impactStatus}}" eipTooltipPosition="auto">
                    {{dataItem.impactStatus ? dataItem.impactStatus + '/ ' : ''}}  {{dataItem.impactDateClosure | date:'dd-MMM-yyyy'}}
                </span>
              </ng-template>
            </kendo-grid-column> -->
            <!-- <kendo-grid-column title="Date Closure" width="100" [minResizableWidth]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>{{dataItem.impactDateClosure | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
            </kendo-grid-column> -->

            <!-- <kendo-grid-column title="Disagree Reason" field="disAgree_Reason" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.disAgree_Reason}}" eipTooltipPosition="auto">
                    {{dataItem.disAgree_Reason}}
                </span>
              </ng-template>
            </kendo-grid-column> -->
            <!-- <kendo-grid-column title="Disagree Remarks" field="disAgree_Reason_Remarks" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.disAgree_Reason_Remarks}}" eipTooltipPosition="auto">
                    {{dataItem.disAgree_Reason_Remarks}}
                </span>
              </ng-template>
            </kendo-grid-column> -->

              <kendo-grid-column title="Impacts" field="impacts" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="no-wrap" eipTooltip="{{dataItem.impacts}}" eipTooltipPosition="auto">
                      {{dataItem.impacts}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Evidence Attachments" width="80">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.evidence_Attachment_Available=='Yes'; else not">
                    <i aria-hidden="true" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewImpactsAttachmentClick(dataItem)"></i>
                  </div>
                </ng-template>
                <ng-template #not>
                  No
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-excel fileName="PeerReviewFinalReport.xlsx" [fetchData]="allData">
              </kendo-grid-excel>
            
            <!-- <kendo-grid-column title="Evidence Remarks" field="evidence_Remarks" width="100">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.evidence_Remarks}}" eipTooltipPosition="auto">
                    {{dataItem.evidence_Remarks}}
                </span>
              </ng-template>
            </kendo-grid-column> -->
            

          </kendo-grid>
      </div>
    </mat-expansion-panel>
  
    </mat-accordion>
  </div>
</div>